import * as tslib_1 from "tslib";
import { Component } from "./Component";
import { BaseComponent } from "./BaseComponent";
var AsyncScope = /** @class */ (function (_super) {
    tslib_1.__extends(AsyncScope, _super);
    function AsyncScope() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AsyncScope.prototype.getDefaultOptions = function () {
        return {
            placeholder: "Loading..."
        };
    };
    AsyncScope.prototype.render = function (childNodes) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, placeholder, options;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                Promise.all(Array.prototype.concat.apply([], childNodes))
                    .then(function (childNodesContent) {
                    _this.getHostElement().replaceWith(childNodesContent);
                    Component.mountRenderedComponents();
                });
                _a = this.options, placeholder = _a.placeholder, options = tslib_1.__rest(_a, ["placeholder"]);
                return [2 /*return*/, $("<div>", tslib_1.__assign({}, options, { html: placeholder }))];
            });
        });
    };
    return AsyncScope;
}(BaseComponent));
export { AsyncScope };
//# sourceMappingURL=AsyncScope.js.map


//////////////////
// WEBPACK FOOTER
// ../~/xm-ui/components/AsyncScope.js
// module id = 34
// module chunks = 1